import { CartItem } from "#sitis/internal/controllers/cart/models/CartItem";
import { CheckoutData } from "#sitis/internal/controllers/cart/models/CheckoutData";
export class CartUseCase {
  constructor(agent) {
    this.agent = agent;
  }
  async getCartItems() {
    try {
      const res = await this.agent.get("/cart").then((res2) => res2._data);
      return res.map((item) => new CartItem(item).toJSON());
    } catch (ex) {
      throw ex;
    }
  }
  async addItemToCart(body) {
    try {
      const reqBody = {
        product_id: body.productId,
        quantity: body.quantity
      };
      if (body.modificationId) {
        reqBody.modification_id = body.modificationId;
      }
      if (body.data) {
        reqBody.data = body.data;
      }
      if (body.options) {
        reqBody.options = body.options;
      }
      const response = await this.agent.post("/cart", { body: { ...reqBody } });
      if (response._data) {
        return new CartItem(response._data).toJSON();
      }
    } catch (ex) {
      throw ex;
    }
  }
  async removeItemFromCart(id) {
    try {
      const response = await this.agent.delete(`/cart/${id}`);
      return true;
    } catch (ex) {
      throw ex;
    }
  }
  async clearCart() {
    try {
      const response = await this.agent.delete("/cart");
    } catch (ex) {
      throw ex;
    }
  }
  async updateCartItem(cartItemId, params) {
    try {
      const response = await this.agent.put(`/cart/${cartItemId}`, {
        body: { ...params }
      });
      return true;
    } catch (ex) {
      throw ex;
    }
  }
  async getCheckoutData() {
    const response = await this.agent.get("checkout/data").then((res) => res._data).catch((err) => {
      throw err.response;
    });
    if (response) {
      return new CheckoutData(response).toJSON();
    }
  }
}
